import { useCrmUrl } from '@/utils/crm-url';

type FreshShipmentLinkProps = {
  freshShipmentId: string;
  name: string;
};

export const FreshShipmentLink = ({
  freshShipmentId,
  name,
}: FreshShipmentLinkProps) => {
  const crmUrl = useCrmUrl();
  if (!crmUrl) {
    return name;
  }

  const url = new URL('main.aspx', crmUrl);
  url.searchParams.set('etc', '10114');
  url.searchParams.set(
    'extraqs',
    'formid=32bc5322-4eee-4b38-a838-d7ffe4d32ca0',
  );
  url.searchParams.set('id', `{${freshShipmentId}}`);
  url.searchParams.set('pagetype', 'entityrecord');
  url.hash = '752549864';

  return (
    <a href={url.toString()} target="_blank" rel="noopener noreferrer">
      {name}
    </a>
  );
};
